const updateAccessInLocalStorage = (accessArray) => {
  let user = JSON.parse(localStorage.getItem("zaffa-admin"));
  user = { ...user, access: accessArray };
  localStorage.setItem("zaffa-admin", JSON.stringify(user));
};

export default updateAccessInLocalStorage;
